import {useViewjobProctorAllocation} from "../../proctor/__generated__/ViewjobProctorContext";
import {RnJsProMobVjEmpInsightsTst} from "../../proctor/__generated__/ViewjobProctorSpecifications";

export function useIsJsProMobVjEmpInsightsTstActive(): boolean {
    const proctorAllocation = useViewjobProctorAllocation(RnJsProMobVjEmpInsightsTst);
    return proctorAllocation.value > 0;
}
